














import { PropType, defineComponent } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import { Clinic } from '../types';

export default defineComponent({
  name: 'ClinicsList',
  components: {
    SfLink,
  },
  props: {
    clinics: {
      type: Array as PropType<Clinic>,
      default: () => [],
    },
  },
});
